var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"terms"},[_c('iframe',{staticClass:"terms__content",attrs:{"title":"TermsOfService","src":_vm.tosUrl}})])}
var staticRenderFns = []

export { render, staticRenderFns }